/**
 * Scroll-Following Media Gallery
 * Adjusts media gallery padding to follow content on the right side
 */

class ScrollFollowingMediaGallery {
  constructor() {
    this.mediaWrapper = null;
    this.infoWrapper = null;
    this.originalTop = 0;
    this.originalPadding = 0;
    this.maxOffset = 0;
    this.ticking = false;
    
    this.init();
  }

  init() {
    // Only run on desktop
    if (window.innerWidth < 750) return;
    
    // Only run on build-your-own product pages
    const buildYourOwnBlock = document.querySelector('.build-your-own');
    
    if (!buildYourOwnBlock) return;
    
    // Find the elements
    this.mediaWrapper = document.querySelector('.product__media-wrapper');
    this.infoWrapper = document.querySelector('.product__info-wrapper');
    
    if (!this.mediaWrapper || !this.infoWrapper) return;
    
    // Store original positions
    this.storeOriginalPositions();
    
    // Set up scroll listener
    this.setupScrollListener();
    
    // Handle resize
    window.addEventListener('resize', () => {
      if (window.innerWidth < 750) {
        this.resetPadding();
      } else {
        this.storeOriginalPositions();
      }
    });
  }

  storeOriginalPositions() {
    const mediaRect = this.mediaWrapper.getBoundingClientRect();
    const infoRect = this.infoWrapper.getBoundingClientRect();
    const computedStyle = window.getComputedStyle(this.mediaWrapper);
    
    this.originalTop = mediaRect.top + window.scrollY;
    this.originalPadding = parseInt(computedStyle.paddingTop) || 0;
    
    // Calculate header + announcement bar height
    this.headerHeight = this.calculateHeaderHeight();
    
    // Calculate max offset dynamically based on viewport and container heights
    const viewportHeight = window.innerHeight;
    const availableViewportSpace = viewportHeight - this.headerHeight; // Space after header
    
    // Calculate how much the media can scroll within the viewport
    const mediaVisibleHeight = Math.min(mediaRect.height, availableViewportSpace);
    const infoVisibleHeight = Math.min(infoRect.height, availableViewportSpace);
    
    // Max offset should allow media to reach the bottom of info container
    // Account for the difference in how much each container can be visible in viewport
    const heightDifference = infoRect.height - mediaRect.height;
    const viewportAdjustment = Math.max(0, mediaRect.height - availableViewportSpace);
    
    this.maxOffset = Math.max(200, heightDifference + viewportAdjustment);
    
  }

  calculateHeaderHeight() {
    let totalHeight = 0;
    
    // Check for announcement bar
    const announcementBar = document.querySelector('.announcement-bar, .utility-bar, [class*="announcement"]');
    if (announcementBar) {
      totalHeight += announcementBar.offsetHeight;
    }
    
    // Check for header
    const header = document.querySelector('.header, .site-header, [class*="header"]');
    if (header) {
      totalHeight += header.offsetHeight;
    }
    
    // Fallback to 130px if no elements found
    return totalHeight > 0 ? totalHeight : 130;
  }

  setupScrollListener() {
    window.addEventListener('scroll', () => {
      if (!this.ticking) {
        requestAnimationFrame(() => {
          this.handleScroll();
          this.ticking = false;
        });
        this.ticking = true;
      }
    });
  }

  handleScroll() {
    if (window.innerWidth < 750) return;
    
    const scrollY = window.scrollY;
    
    // Calculate how much we've scrolled past the original position
    // Start earlier by beginning before the original position
    const scrollPastOriginal = Math.max(0, scrollY - this.originalTop + 30); // Start 93px earlier
    
    // Direct 1:1 scroll-to-padding ratio for exact movement
    const paddingOffset = Math.min(this.maxOffset, scrollPastOriginal);
    
    
    // Apply the padding
    this.adjustPadding(paddingOffset);
  }

  adjustPadding(offset) {
    const newPaddingTop = this.originalPadding + offset;
    this.mediaWrapper.style.paddingTop = `${newPaddingTop}px`;
  }

  resetPadding() {
    this.mediaWrapper.style.paddingTop = '';
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ScrollFollowingMediaGallery();
  });
} else {
  new ScrollFollowingMediaGallery();
}
